import { render, staticRenderFns } from "./KBTime.vue?vue&type=template&id=4aa4b66f&scoped=true&"
import script from "./KBTime.vue?vue&type=script&lang=ts&"
export * from "./KBTime.vue?vue&type=script&lang=ts&"
import style0 from "./KBTime.vue?vue&type=style&index=0&id=4aa4b66f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4b66f",
  null
  
)

export default component.exports